<template>
    <v-card min-width="20vw" align="center" justify="center" light outlined>
        <v-card-title style="background-color: #d2d7e1">
            <v-list-item>
                <v-list-item-title><h2>{{ $t('deleteStrategy') }}</h2></v-list-item-title>
                <v-spacer/>
                <v-list-item-action><v-icon class="icon" @click="cancelDelete" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="px-7 py-7">
            <p v-html="$t('areYouSureToDeleteStrategy',{strategyName: strategy.name})"></p>
            <v-btn @click="deleteStrategy">{{ $t('yesDeleteIt') }}</v-btn>
        </v-card-text>
    </v-card>
</template>

<script>
    import Repository from '../../repositories/strategy';
    import { mapMutations } from 'vuex';
    export default {
        name: "DeleteStrategy",
        props: {
            strategy: Object,
        },
        methods: {
            ...mapMutations(['setStrategies']),
            async deleteStrategy() {
                await Repository.deleteStrategyToUser(this.strategy.id).then(async (response) => {
                    if(response.status < 400) {
                        if(response.data)
                            Repository.allStrategiesOfUser().then((responseAll) => {
                                this.setStrategies(responseAll.data);
                            });
                        else
                            alert(this.$t('alertMessage'))
                    }
                });
                this.$emit('closeDeleteWindow');
            },
            cancelDelete() {
                this.$emit("closeDeleteWindow");
            },
        }
    }
</script>

<style scoped>

</style>


<i18n>
{
  "en": {
    "deleteStrategy": "Delete Strategy",
    "areYouSureToDeleteStrategy": "Are you sure to delete the strategy <b>{strategyName}</b>?",
    "yesDeleteIt": "Yes, delete it",
    "alertMessage": "You cannot delete the strategy.\nThere are trades registered with this strategy in the journal. If you want to delete it, you need to unsubscribe the strategy for all the trades."
  },
  "es":{
    "deleteStrategy": "Eliminar Estrategia",
    "areYouSureToDeleteStrategy": "¿Estas seguro de eliminar la estrategia <b>{strategyName}</b>?",
    "yesDeleteIt": "Si, eliminalo",
    "alertMessage": "No puedes eliminar esta estrategia.\nAun hay trades registrados con ella en la bitácora. Si desea eliminarla, debes de quitarla de todos los trades."
  }
}
</i18n>
